import { isEmpty } from 'utils/isEmpty';

export function getEntityField(entity, field) {
    if (entity && typeof entity.get === 'function') {
        return entity.get(field);
    }
    return entity?.[field];
}

export function isTiposValues(value, strValues) {
    if (!value) return true;
    const strValue = value.toString();
    return !strValues
        .split(';')
        .filter((v) => !!v)
        .includes(strValue);
}

export function getLegacyFormErrors(schema, entity, dynamic) {
    let errors = {};
    let firstErrorField = null;

    schema.forEach((element) => {
        element.tabFields.forEach((field) => {
            if (field.dataType === 'break') return;
            let id = typeof field.id === 'object' ? field.id.id : field.id;
            id = id.toLowerCase();
            const readOnly = field.readOnly && getEntityField(entity, 'id');

            if (
                field.mandatory &&
                !readOnly &&
                isEmpty(getEntityField(entity, id)) &&
                (isEmpty(field.TiposEntity) ||
                    field.strTiposEntity === -1 ||
                    field.strTiposEntity === '-1' ||
                    (!isEmpty(field.TiposEntity) &&
                        !isTiposValues(
                            getEntityField(dynamic, field.TiposEntity.toLowerCase()),
                            field.strTiposEntity,
                        )))
            ) {
                errors[id.toLowerCase()] = '  ';
                if (!firstErrorField) {
                    firstErrorField = id.toLowerCase();
                }
            }
        });
    });

    return { errors, firstErrorField };
}
